//
// Cookie Consent functions
//
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

export default class CookieConsentConfig {
  constructor() {

  // Initialize and configure Cookie Consent
  CookieConsent.run({
    guiOptions: {
      consentModal: {
          position: 'middle center'
      },
    },

    categories: {
      necessary: {
        enabled: true,
      readOnly: true
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/,
            },
            {
              name: '_gid',
            }
          ]
        },
        services: {
          ga: {
            label: 'Google Analytics',
            onAccept: () => {},
            onReject: () => {},
            cookies: [
              {
                name: /^(_ga|_gid)/
              }
            ]
          }
        }
      }
    },

    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description: 'This website uses first and third-party cookies to ensure you get the best experience on our website.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage Individual preferences',
            // footer: `
            //   <a href="/privacy-policy">Privacy Policy</a>
            // `,
          },
          preferencesModal: {
            title: 'Manage cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Accept current selection',
            closeIconLabel: 'Close modal',
            serviceCounterLabel: 'Service|Services',
            sections: [
              {
                title: 'Your Privacy Choices',
                description: `In this panel you can express some preferences related to cookies used on this website. You may review and change expressed choices at any time by resurfacing this panel via the link in the footer. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
              },
              {
                title: 'Strictly Necessary',
                description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                linkedCategory: 'necessary',
                cookieTable: {
                  headers: {
                    name: 'Cookie',
                    domain: 'Domain',
                    expires: 'Expiration',
                    desc: 'Description'
                  },
                  body: [
                    {
                      name: 'cc_cookie',
                      domain: location.hostname,
                      expires: '182 days',
                      desc: 'Remembers your cookie preferences.',
                    },
                    {
                      name: 'CraftSessionId',
                      domain: location.hostname,
                      expires: 'Session',
                      desc: 'Persists session state.',
                    },
                    {
                      name: 'CRAFT_CSRF_TOKEN',
                      domain: location.hostname,
                      expires: 'Session',
                      desc: 'Protexts against CSFR attacks.',
                    },
                    {
                      name: '*_identity',
                      domain: location.hostname,
                      expires: 'While logged in',
                      desc: 'Maintains a secure, authenticated session.',
                    },
                    {
                      name: '*_username',
                      domain: location.hostname,
                      expires: '1 year',
                      desc: 'Remembers your username when logging in.',
                    }
                  ]
                }
              },
              {
                title: 'Performance and Analytics',
                description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                linkedCategory: 'analytics',
                cookieTable: {
                  headers: {
                    name: 'Cookie',
                    domain: 'Domain',
                    expires: 'Expiration',
                    desc: 'Description'
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: 'google.com',
                      expires: '2 years',
                      desc: 'Used by Google Analytics to distingish users.',
                    },
                    {
                      name: '_gid',
                      domain: 'google.com',
                      expires: '2 years',
                      desc: 'Used by Google Analytics to persist session state.',
                    }
                  ]
                }
              },
              {
                title: 'More information',
                description: 'For any queries in relation to these cookies and your choices, please <a href="/contact-us">contact us</a>'
              }
            ]
          }
        }
      }
    }
  });

  }
}